import React from 'react'
import HomeCard from "../Components/HomeCard";

const HomeSection = (props) => {
 
    
  return (
    <div className=''>

        <div className=" md:container max-w-[95%] md:max-w-[90%] mx-auto mt-5">
                <h1 className="text-violet-900 md:text-3xl text-xl font-extrabold mb-3">
                    {props.name}
                </h1>
                <div className="grid lg:grid-cols-4    grid-cols-2 grid-rows-1 justify-between md:gap-5 gap-2">
                    {/* One Card */}
                    <HomeCard product={ props.product[0] }/>
                    <HomeCard product={ props.product[1] }/>
                    <HomeCard product={ props.product[2] }/>
                    <HomeCard product={ props.product[3] }/>
                </div>
        </div>

    </div>
  )
}

export default HomeSection